import { createElement } from "react";
import { api } from "../lib/api";
import { confirm, confirmWith } from "./ui/Dialog";
import { IconLogout, IconTrash } from "./icons";

/*
 * Ready-made "Are you sure?" prompts so the same action always asks the same way.
 * All of them use the shared confirmation modal (ConfirmHost).
 */

export function confirmDeleteCommunity(name: string) {
  return confirm({
    title: `Delete ${name}?`,
    description: "This permanently deletes the community for everyone. It can't be undone.",
    icon: IconTrash,
    danger: true,
    consequences: ["Every channel, message and pin is deleted", "Roles, invites, bans and the audit log are removed", "Members lose access immediately"],
    requireText: name,
    confirmLabel: "Delete community",
  });
}

export function confirmDeletePost(opts: { hasReplies?: boolean; isQuoted?: boolean } = {}) {
  return confirm({
    title: "Delete post?",
    description: "It's removed from your profile, the feed and search.",
    icon: IconTrash,
    danger: true,
    consequences: [
      "Likes and reposts are removed",
      opts.hasReplies === false ? null : "Replies are deleted with it",
      opts.isQuoted ? "Posts quoting it will show it as unavailable" : null,
    ].filter(Boolean) as string[],
    confirmLabel: "Delete post",
  });
}

/**
 * Ask before signing out, optionally ending every other session too.
 * Returns true when the user went ahead (the caller performs the sign-out).
 */
export async function confirmSignOut(): Promise<boolean> {
  const r = await confirmWith({
    title: "Sign out of Atrium?",
    description: "You'll need your password to sign back in on this device.",
    icon: IconLogout,
    checkbox: { label: "Also sign out on all my other devices" },
    confirmLabel: "Sign out",
  });
  if (!r.confirmed) return false;
  if (r.checked) await api.del("/api/me/sessions").catch(() => {});
  return true;
}
